import type { FaireProductEntity } from "../../entity_types/product";

export const p_a9k3wha74u: FaireProductEntity = {
  token: "p_a9k3wha74u",
  type: "product",
  name: "COLOMBIA SUGARCANE DECAF",
  brandToken: "b_8rgv5suw2a",
  brandName: "Portrait Coffee",
  imageUrl: "https://cdn.faire.com/fastly/05d8f78b241881aaff13d01ed0b7f9864aba868ee10b87ebeaaeb629616593cb.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c3c9a5fff6904762a863968b02dc32993e0f93cb2d30f327602ec9f1739fbff6.png",
    "https://cdn.faire.com/fastly/11fb36999a68a1cffc17fef2f17fd302cdb4b7708c3abdb340461cb956fa3c91.png",
    "https://cdn.faire.com/fastly/3617e5a653261b1be93bb77bd56eb6c11cddf627b10222bed30e8aab6caa8b8d.png"
  ],
  priceDollars: 12,
  description: "Notes: Caramel & dried cherry\n\nProcess: Sugarcane Decaf\n\nRegion: Valle del Cauca\n\nVarieties: Castillo, Caturra\n\nAltitude: 1750 masl\n\nAbout the Producer: After much cupping and searching, Portrait has finally found the perfect cup of decaf coffee! Our Valle del Cauca Excelso was decaffeinated in Colombia using ethyl acetate - an organic compound derived from sugar cane - to remove 97% of the caffeine from coffee beans. The process tends to leave a pleasantly sugary flavor. You’ll grab notes of caramel & dried cherry out of this delicious coffee.\n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:46.727Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
